export function autofocus(element) {
    element.focus();
}
